import styled from 'styled-components'

// Note: The field chrome (border, background, height, states, error colors) lives
// in `TextInput`. This file only owns what `TextInput` can't provide: the country
// selector that sits in the leading slot and the country dropdown. The selector is
// transparent and inherits color/size from `TextInput`'s `LeadingSlot`.

export const CountrySelector = styled.button(({ theme }) => ({
  '& *': {
    cursor: 'pointer',
  },
  '&:disabled, &:disabled *': {
    cursor: 'not-allowed',
  },
  alignItems: 'center',
  background: 'transparent',
  border: 'none',
  color: 'inherit',
  cursor: 'pointer',
  display: 'flex',
  flexShrink: 0,
  fontSize: 'inherit',
  gap: theme.space['4'],
  lineHeight: 'inherit',
  outline: 'none',
  padding: 0,
}))

export const DialCode = styled.span(() => ({
  color: 'inherit',
  fontSize: 'inherit',
  fontWeight: 500,
}))

export const CaretIcon = styled.span<{ $isOpen: boolean }>(({ $isOpen }) => ({
  alignItems: 'center',
  color: 'inherit',
  display: 'flex',
  transform: $isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.2s ease',
}))

export const Dropdown = styled.div(({ theme }) => ({
  background: theme.colors.white,
  border: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  borderRadius: theme.border.radius['4'],
  boxShadow: theme.shadow.lg,
  maxHeight: '28rem',
  overflowY: 'auto',
  paddingBottom: theme.space['4'],
  paddingTop: theme.space['8'],
  zIndex: theme.zIndex.level1,
}))

export const SearchInput = styled.input(({ theme }) => ({
  '&::placeholder': {
    color: theme.colors.primary500,
  },

  background: theme.colors.gray100,
  border: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  borderRadius: theme.border.radius['4'],
  color: theme.colors.primary800,
  fontSize: '1.4rem',
  margin: `${theme.space['0']} ${theme.space['12']} ${theme.space['8']}`,
  outline: 'none',
  padding: theme.space['8'],
  width: `calc(100% - ${theme.space['24']})`,
}))

export const Option = styled.button<{ $isSelected: boolean }>(({ theme, $isSelected }) => ({
  '&:focus': {
    backgroundColor: theme.colors.gray300,
    outline: 'none',
  },

  '&:hover': {
    backgroundColor: theme.colors.gray200,
  },

  alignItems: 'center',
  backgroundColor: $isSelected ? theme.colors.gray300 : theme.colors.white,
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  fontSize: '1.4rem',
  fontWeight: $isSelected ? 600 : 400,
  gap: theme.space['8'],
  padding: `${theme.space['8']} ${theme.space['12']}`,
  textAlign: 'left',
  transition: `background-color ${theme.transition.duration.sm} ease`,
  width: '100%',
}))

export const OptionName = styled.span(({ theme }) => ({
  color: theme.colors.primary800,
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

export const OptionDialCode = styled.span(({ theme }) => ({
  color: theme.colors.black500,
  flexShrink: 0,
}))
